// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d4f9dec0","977":"93f279b8"}[chunkId] + ".chunk.js";
};